<style scoped>
.br-10 {
  border-radius: 10px;
}
.ellipsis {
  white-space: nowrap;
  width: 250px;
  text-overflow: ellipsis;
}
</style>

<template>
  <v-container fluid>
    <span class="text-caption" v-if="loading">{{ $t('searching') }}</span>
    <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
    <br  v-if="loading"/>
    <v-alert v-if="error" id="error" :value="error !== null" class="br-10 dark font-weight-medium" type="error" dismissible>{{ error.message | uppercase }}</v-alert>
    <v-layout justify-center class="pb-3">
      <v-flex xl6 lg6 md8 sm10 xs12>
        <v-card class="br-10 pa-8 elevation-3" color="blue lighten-4">
          <v-form @submit.prevent="searchData()">
            <span class="caption"><h2>{{ $t('page_assessment.index.header') }}</h2></span>
            <v-text-field :value="data.searchId" @input="patchData({ searchId: $event })" :placeholder="$t('searches')"/>
            <span class="caption"><strong>{{ $t('page_assessment.index.hint') }}</strong></span>
            <v-layout reverse row class="mt-2">
              <v-btn :disabled="data === {} || data.searchId === undefined || data.searchId === ''" color="primary" large rounded type="submit">{{ $t('page_assessment.index.search') }}</v-btn>
            </v-layout>
          </v-form>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout justify-center>
      <v-flex xl6 lg6 md8 sm10 xs12>
        <v-list v-if="listData.length > 0" three-line class="br-10 elevation-3">
          <v-subheader class="black--text body-2"><h3>{{ $t('page_assessment.index.result') }}</h3></v-subheader>
          <v-divider/>
          <div v-for="item in listData" :key="item._id">
            <v-list-item ripple style="cursor: pointer;">
              <v-list-item-action class="pl-2 pt-2">
                <v-checkbox :value="item._id" :input-value="data._id" @change="setData({ data: { _id: item._id } })"/>
              </v-list-item-action>
              <v-list-item-content @click.stop="setData({ data: { _id: item._id } })">
                <v-list-item-title class="body-1"><strong>{{ $t('page_assessment.index.assessment_no') }} : {{ item.assessment_account_id }}</strong></v-list-item-title>
                <v-list-item-subtitle><h4>{{ $t('page_assessment.index.property_id') }} : {{ item.property ? item.property.id : '-' }}</h4></v-list-item-subtitle>
                <v-list-item-subtitle class="ellipsis"><h4>{{ $t('page_assessment.index.name') }} : {{ item.ownership.length > 0 ? hideText(item.ownership[0].name) : '-' }}</h4></v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </div>
          <v-layout v-if="listData.length > 0" reverse row class="pa-5">
            <v-btn :disabled="data._id === undefined || data._id === ''" @click="redirect(data)" class="mt-3" color="primary" large nuxt align-right rounded>{{ $t('page_assessment.index.proceed') }}</v-btn>
          </v-layout>
        </v-list>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import vuex from 'vuex'

export default {
  beforeDestroy () {
    this.$store.commit('search/setError', { error: null })
    this.$store.commit('search/setLoading', { loading: false })
  },
  beforeMount () {
    this.$store.commit('search/setListData', { listData: [] })
  },
  computed: {
    ...vuex.mapState({
      data: state => state.search.data,
      error: state => state.search.error,
      loading: state => state.search.loading,
      listData: state => state.search.listData
    })
  },
  methods: {
    ...vuex.mapActions({
      patchData: 'search/patchData',
      resetData: 'search/resetData',
      searchData: 'search/searchData'
    }),
    ...vuex.mapMutations({
      setData: 'search/setData'
    }),
    redirect (data) {
      return this.$router.push({ name: 'assessment-id', params: { id: btoa(data._id) } })
    },
    hideText (text) {
      if (!text || text.length === 0) return
      var t = text || ''
      var hiddenText = ''
      for (var i = 0; i < t.length; i++) {
        if (i > 4) {
          hiddenText += '*'
        } else {
          hiddenText += t[i]
        }
      }
      return hiddenText
    }
  }
}
</script>
